
    import I18n from 'i18nObj';
    
      import 'translations/edit_rubric';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('edit_rubric');
  